import React from 'react';
import './LivePreview.css';

const LivePreview = ({ 
  formData, 
  className = '' 
}) => {
  const previewStyle = {
    '--primary-color': formData.primary_color || '#4783ed',
    '--secondary-color': formData.secondary_color || '#81a8ec',
    '--text-color': formData.text_color || '#333333',
    '--text-light-color': formData.text_light_color || '#666666',
    '--text-dark-color': formData.text_dark_color || '#000000',
    '--text-on-primary': formData.text_on_primary || '#ffffff',
    '--active-color': formData.active_color || '#ffffff',
    '--background-color': formData.background_color || '#f8f9fa',
    '--background-light': formData.background_light || '#ffffff',
    '--background-dark': formData.background_dark || '#f0f0f0',
    '--border-color': formData.border_color || '#dee2e6',
    '--border-focus': formData.border_focus || '#4783ed',
    '--success-color': formData.success_color || '#28a745',
    '--error-color': formData.error_color || '#dc3545',
    '--warning-color': formData.warning_color || '#ffc107',
    '--info-color': formData.info_color || '#17a2b8',
  };

  return (
    <div className={`live-preview ${className}`} style={previewStyle}>
      <div className="live-preview-header">
        <h3 className="live-preview-title">
          <span className="live-preview-icon">👁️</span>
          Живой предпросмотр
        </h3>
        <div className="live-preview-badge">
          <span className="live-preview-badge-icon">⚡</span>
          Обновляется в реальном времени
        </div>
      </div>

      <div className="live-preview-content">
        {/* Навигация */}
        <div className="live-preview-nav">
          <div className="live-preview-nav-brand">
            <div className="live-preview-logo">
              {formData.logo_url ? (
                <img 
                  src={formData.logo_url} 
                  alt="Логотип" 
                  className="live-preview-logo-img"
                />
              ) : (
                <div className="live-preview-logo-placeholder">
                  <span className="live-preview-logo-text">LOGO</span>
                </div>
              )}
            </div>
            <span className="live-preview-brand-name">Ваш сайт</span>
          </div>
          <div className="live-preview-nav-menu">
            <button className="live-preview-nav-item active">Главная</button>
            <button className="live-preview-nav-item">О нас</button>
            <button className="live-preview-nav-item">Услуги</button>
            <button className="live-preview-nav-item">Контакты</button>
          </div>
        </div>

        {/* Основной контент */}
        <div className="live-preview-main">
          <div className="live-preview-hero">
            <h1 className="live-preview-hero-title">Добро пожаловать!</h1>
            <p className="live-preview-hero-description">
              Это пример того, как будут выглядеть ваши страницы с выбранными цветами
            </p>
            <div className="live-preview-hero-actions">
              <button className="live-preview-btn primary">Начать</button>
              <button className="live-preview-btn secondary">Узнать больше</button>
            </div>
          </div>

          {/* Карточки */}
          <div className="live-preview-cards">
            <div className="live-preview-card">
              <div className="live-preview-card-icon">📊</div>
              <h3 className="live-preview-card-title">Аналитика</h3>
              <p className="live-preview-card-description">
                Отслеживайте эффективность вашего сайта
              </p>
              <button className="live-preview-card-btn">Подробнее</button>
            </div>

            <div className="live-preview-card">
              <div className="live-preview-card-icon">⚡</div>
              <h3 className="live-preview-card-title">Производительность</h3>
              <p className="live-preview-card-description">
                Быстрая загрузка и отличная работа
              </p>
              <button className="live-preview-card-btn">Подробнее</button>
            </div>

            <div className="live-preview-card">
              <div className="live-preview-card-icon">🔒</div>
              <h3 className="live-preview-card-title">Безопасность</h3>
              <p className="live-preview-card-description">
                Защита данных и конфиденциальность
              </p>
              <button className="live-preview-card-btn">Подробнее</button>
            </div>
          </div>

          {/* Форма */}
          <div className="live-preview-form">
            <h3 className="live-preview-form-title">Свяжитесь с нами</h3>
            <div className="live-preview-form-group">
              <input 
                type="text" 
                placeholder="Ваше имя" 
                className="live-preview-input"
              />
              <input 
                type="email" 
                placeholder="Email" 
                className="live-preview-input"
              />
              <textarea 
                placeholder="Сообщение" 
                className="live-preview-textarea"
                rows="3"
              />
              <button className="live-preview-btn primary">Отправить</button>
            </div>
          </div>

          {/* Уведомления */}
          <div className="live-preview-notifications">
            <div className="live-preview-notification success">
              <span className="live-preview-notification-icon">✓</span>
              <span className="live-preview-notification-text">Успешно сохранено!</span>
            </div>
            <div className="live-preview-notification warning">
              <span className="live-preview-notification-icon">⚠</span>
              <span className="live-preview-notification-text">Внимание: проверьте данные</span>
            </div>
            <div className="live-preview-notification error">
              <span className="live-preview-notification-icon">✗</span>
              <span className="live-preview-notification-text">Ошибка: что-то пошло не так</span>
            </div>
          </div>
        </div>

        {/* Футер */}
        <div className="live-preview-footer">
          <div className="live-preview-footer-content">
            <div className="live-preview-footer-brand">
              <span className="live-preview-footer-logo">LOGO</span>
              <span className="live-preview-footer-text">© 2024 Ваш сайт. Все права защищены.</span>
            </div>
            <div className="live-preview-footer-links">
              <a href="#" className="live-preview-footer-link">Политика конфиденциальности</a>
              <a href="#" className="live-preview-footer-link">Условия использования</a>
              <a href="#" className="live-preview-footer-link">Контакты</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LivePreview;
